import { InnerQueryExpression } from "../InnerQueryExpression";

export class NotExpression implements InnerQueryExpression {
    public readonly $discriminator = "Not";
    public readonly expression: InnerQueryExpression;
    public constructor(expression: InnerQueryExpression) {
        this.expression = expression;
    }
}
